import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

import { isPageInPopupHasThemeHeader } from '../helpers';

export const useGetIsPageAsPopupHasCustomHeader = () => {
    const { pathname } = useLocation();
    const dynamicTags = useAppSelector(prop('dynamicTags'));

    return useMemo(() => isPageInPopupHasThemeHeader(dynamicTags, pathname),
        [dynamicTags, pathname]
    );
};
